import clz from 'classnames';
import { FunctionComponent } from 'react';
import { nanoid } from 'nanoid';

import styles from './LinkGroup.module.sass';

export interface Link {
    text: string;
    path: string;
    newWin?: boolean;
    disabled?: boolean;
}

export interface LinkGroupProps {
    title: string;
    links: Link[];
}

const LinkGroup: FunctionComponent<LinkGroupProps> = ({ title, links }) => {
    const linkComps = links.map((alink) => (
        <a
            className={clz(styles.link, { [styles.disabled]: alink.disabled })}
            key={nanoid()}
            href={alink.path}
            target={alink.newWin ? '_blank' : '_self'}
        >
            {alink.text}
        </a>
    ));
    return (
        <div className={styles.container}>
            <h4 className={styles.groupTitle}>{title}</h4>
            {linkComps}
        </div>
    );
};

export default LinkGroup;
